import AppRoutes from "./routes";
import { Fragment } from "react/jsx-runtime";
import  useStore  from "./hooks/useStore";
import { useEffect } from "react";
import useHttp from "./hooks/useHttp";
import useFirebase from "hooks/useFirebse";

function App() {
  const { configureHeaders, configureInterceptors} = useHttp();
  const { setLoading, getToken } = useStore();
  const token = getToken();
  const { getNotificationPermission, registerServiceWorker } = useFirebase();

  configureInterceptors();
  useEffect(() => {
    setLoading(false);
    configureHeaders();
    registerServiceWorker();
    if(token){
      getNotificationPermission();
    }
  }, []);

  return (
    <Fragment>
      <AppRoutes />
    </Fragment>
  );
}

export default App;
